import CustomTable from 'pages/Event/EventWater/CustomTable'
import imgBoat2 from 'assets/images/eventBoatRacing/imgBoat2.png'
import React from 'react'
import { useTranslation } from 'react-i18next'

function BoatRacingDetail({ columns, data }) {
	const { t } = useTranslation()

	return (
		<div className="box-tab-content-detail">
			<div className="wapper-detail">
				<img srcSet={`${imgBoat2} 2x`} alt="icon page" />
				<div className="wapper-detail-box">
					<div className="wapper-detail-box-content">
						<p level={3} className="wapper-detail-box-content-title">
							{' '}
							<span>{t('event.boat_racing.detail.title')}</span>
						</p>
						<p>
							<span>{t('event.boat_racing.detail.text_d1_1')}</span>{' '}
							{t('event.boat_racing.detail.text_d1_2')}
						</p>

						<p>
							<span>{t('event.boat_racing.detail.text_d2_1')} </span>
							{t('event.boat_racing.detail.text_d2_2')}
							<ul>
								<li>{t('event.boat_racing.detail.text_d3')}</li>
								<li>{t('event.boat_racing.detail.text_d4')}</li>
								<li>{t('event.boat_racing.detail.text_d5')}</li>
							</ul>
						</p>

						<span>{t('event.boat_racing.detail.text_d6_1')}</span>
						<p>{t('event.boat_racing.detail.text_d6_2')}</p>
						<p>
							<span>{t('event.boat_racing.detail.text_d7_1')} </span>
							{t('event.boat_racing.detail.text_d7_2')}
						</p>
						<p>{t('event.boat_racing.detail.text_d8')}</p>
						<p style={{ lineHeight: '12px' }}>
							<span>{t('event.boat_racing.detail.text_d9')}</span>
						</p>
						<CustomTable
							columns={columns}
							dataSource={data}
							style={{ marginBottom: '1em' }}
							pagination={false}
							scroll={{ x: true }}
							bordered
						/>
						<p>{t('event.boat_racing.detail.text_d10')}</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default BoatRacingDetail
